(function () {
  const component = document.querySelector('[data-motion-haltech-stock]');
  if (!component) return;

  const productId = window.MotionHaltechProductId;
  const dataNode = document.getElementById(`MotionHaltechStockData-${productId}`);
  if (!dataNode) return;

  let variants = [];
  try {
    variants = JSON.parse(dataNode.textContent || '[]');
  } catch (error) {
    return;
  }

  const headline = component.querySelector('.motion-haltech-stock__headline');

  function availabilityFor(variant) {
    const raw = String(variant.stockStatus || '').trim();
    const status = raw.toLowerCase().replace(/[\s-]+/g, '_');

    if (['discontinued', 'obsolete'].includes(status)) {
      return { className: 'is-discontinued', headline: 'Discontinued' };
    }

    if (['preorder', 'pre_order'].includes(status)) {
      return { className: 'is-preorder', headline: 'Pre-order' };
    }

    if (['special_order', 'specialorder'].includes(status)) {
      return { className: 'is-backorder', headline: 'Special Order' };
    }

    if (variant.inventoryTracked === true) {
      const quantity = Number(variant.inventoryQuantity || 0);
      if (quantity > 0) {
        return { className: 'is-in-stock', headline: 'In stock' };
      }
      return { className: 'is-backorder', headline: 'Backorder – Will Ship Direct From Supplier' };
    }

    if (variant.available === true) {
      return { className: 'is-in-stock', headline: 'In stock' };
    }

    return { className: 'is-backorder', headline: 'Backorder – Will Ship Direct From Supplier' };
  }

  function render(variantId) {
    const variant = variants.find((item) => String(item.id) === String(variantId)) || variants[0];
    if (!variant) return;

    const state = availabilityFor(variant);
    component.classList.remove(
      'is-in-stock',
      'is-backorder',
      'is-out-of-stock',
      'is-preorder',
      'is-discontinued',
      'is-check'
    );
    component.classList.add(state.className);
    headline.textContent = state.headline;
  }

  function selectedVariantId() {
    const form = document.querySelector('form[action*="/cart/add"]');
    const idInput = form ? form.querySelector('input[name="id"]') : null;
    if (idInput && idInput.value) return idInput.value;

    const url = new URL(window.location.href);
    return url.searchParams.get('variant') || component.dataset.currentVariant;
  }

  render(selectedVariantId());

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('variant-selects select') ||
      event.target.matches('variant-radios input') ||
      event.target.closest('variant-selects') ||
      event.target.closest('variant-radios') ||
      event.target.name === 'id'
    ) {
      window.setTimeout(() => render(selectedVariantId()), 0);
    }
  });

  document.addEventListener('variant:change', function (event) {
    if (event.detail && event.detail.variant) {
      render(event.detail.variant.id);
    }
  });

  window.addEventListener('popstate', function () {
    render(selectedVariantId());
  });

  const observer = new MutationObserver(function () {
    const currentId = selectedVariantId();
    if (currentId) render(currentId);
  });

  const productInfo = document.querySelector('product-info');
  if (productInfo) observer.observe(productInfo, { subtree: true, childList: true, attributes: true });
})();